import { render } from "./akt.vue?vue&type=template&id=c5572c30"
import script from "./akt.vue?vue&type=script&lang=js"
export * from "./akt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__